import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';

const SplitTextTest = ({
  text,
  className = '',
  delay = 0.1,
  duration = 0.6,
  ease = 'power3.out',
  from = { opacity: 0, y: 40 },
  to = { opacity: 1, y: 0 },
  onComplete
}) => {
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (!ref.current || !text || hasAnimated.current) {
      console.log('SplitTextTest: Missing ref, text, or already animated');
      return;
    }

    hasAnimated.current = true;
    console.log('SplitTextTest: Starting animation for text:', text);
    const element = ref.current;
    
    // Split text into characters
    const chars = text.split('').map((char, index) => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? '\u00A0' : char; // Non-breaking space for spaces
      span.style.display = 'inline-block';
      span.style.opacity = '0';
      span.style.transform = 'translateY(40px)';
      return span;
    });

    // Clear element and add characters
    element.innerHTML = '';
    chars.forEach(char => element.appendChild(char));

    console.log('SplitTextTest: Created', chars.length, 'character spans');

    // Animate characters immediately (no scroll trigger)
    gsap.fromTo(chars, 
      from,
      {
        ...to,
        duration,
        ease,
        stagger: delay,
        onComplete: () => {
          console.log('SplitTextTest: Animation complete');
          onComplete?.();
        }
      }
    );
  }, [text, delay, duration, ease, from, to, onComplete]);

  return (
    <span ref={ref} className={className}>
      {text}
    </span>
  );
};

export default SplitTextTest;
